import React, { Component } from 'react';
import arrowIcon from 'assets/images/backoffice/fresh/arrow-icon.svg';
import './PhaseOut.css';

class FaqItem extends Component {
  state = {
    isShow: false,
  };

  toggle = () => {
    this.setState({
      isShow: !this.state.isShow,
    });
  };

  render() {
    const { isShow } = this.state;
    const { title, children } = this.props;
    return (
      <div className="faq-item">
        <div
          className={`faq-action ${isShow ? 'active' : ''}`}
          onClick={this.toggle}
        >
          <p>{title}</p>
          <img src={arrowIcon} />
        </div>
        <div className={`faq-detail ${isShow ? 'active' : ''}`}>
          <div className="faq-detail-content">{children}</div>
        </div>
      </div>
    );
  }
}

export default FaqItem;
